export default __webpack_public_path__ + "static/media/figuremap43.bdf4ea28.png";